import React from 'react';
import PropTypes from 'prop-types';
import 'assets/styles/common.scss';

/**
 * ShimmerBox - A reusable shimmer loading box component
 * @param {string} width - Width of the shimmer box (default: '100%')
 * @param {string} height - Height of the shimmer box (default: '20px')
 * @param {string} className - Additional CSS classes
 * @param {object} style - Additional inline styles
 */
export const ShimmerBox = ({
  width = '100%',
  height = '20px',
  className = '',
  style = {},
}) => {
  return (
    <div
      className={`shimmer shimmer-box ${className}`}
      style={{ width, height, ...style }}
    />
  );
};

ShimmerBox.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

/**
 * ShimmerCircle - A reusable shimmer loading circle component
 * @param {string} size - Size of the shimmer circle (default: '88px')
 * @param {string} className - Additional CSS classes
 * @param {object} style - Additional inline styles
 */
export const ShimmerCircle = ({
  size = '88px',
  className = '',
  style = {},
}) => {
  return (
    <div
      className="shimmer shimmer-circle"
      style={{ width: size, height: size, ...style }}
    />
  );
};

ShimmerCircle.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

/**
 * ShimmerImage - A reusable shimmer loading image placeholder component
 * @param {string} width - Width of the shimmer image (default: '124px')
 * @param {string} height - Height of the shimmer image (default: '124px')
 * @param {string} className - Additional CSS classes
 * @param {object} style - Additional inline styles
 */
export const ShimmerImage = ({
  width = '124px',
  height = '124px',
  className = '',
  style = {},
}) => {
  return (
    <div
      className="shimmer shimmer-image"
      style={{ width, height, ...style }}
    />
  );
};

ShimmerImage.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default {
  ShimmerBox,
  ShimmerCircle,
  ShimmerImage,
};
